import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_HEADERS, ENDPOINTS } from "../../constants/api";
import { baseQueryWithAuthCheck } from "./helper";
import { VerifyServiceResponse } from "../../types/api-response";
import { callFromMiddleware } from "../../utils";
import { VerifyServicePayload } from "../../types/api-payload";

const baseQuery = fetchBaseQuery({
  baseUrl: window.location.origin,
  headers: API_HEADERS,
  credentials: "include",
});

export const verifyServiceAPI = createApi({
  reducerPath: "verify-service",
  baseQuery: baseQueryWithAuthCheck(baseQuery),
  endpoints: (builder) => ({
    getInventoryAllCount: builder.query<VerifyServiceResponse, VerifyServicePayload>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.getInventoryAllCount)}`,
        method: "GET",
        headers: API_HEADERS,
        params: args,
      }),
    }),
    getEjp: builder.query<any,any>({
      query: (args) => {
       return {
        url: `${callFromMiddleware(ENDPOINTS.getEJP)}`,
        method: "GET",
        headers: API_HEADERS,
        params: { corpId: args.corpId, type: args.type }
      }},
    }),
  }),
});

export const {
  useGetInventoryAllCountQuery,
  useGetEjpQuery
} = verifyServiceAPI;

export default verifyServiceAPI;

